import React from 'react';
import PokemonForm from "./components/PokemonForm";

function App() {
  return (
    <div className="App">
      <PokemonForm />
    </div>
  );
}

export default App;
